const formatTime = (timestamp) => {
  return new Date(timestamp).toLocaleTimeString('pl-PL');
};

export default formatTime;
